var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HMTextInput',{attrs:{"name":"included-content-title","label":_vm.$t('PRODUCTS.LABELS.TITLE'),"value":_vm.value.title},on:{"input":function($event){return _vm.handleOnInput('title', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }